import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  school: defineAsyncComponent(() => import("/app/layouts/school.vue").then(m => m.default || m))
}